export default __webpack_public_path__ + "static/media/main-slider-tracking-health.c30e4fed.png";